import makeStyles from '@mui/styles/makeStyles'

export const useStyles = makeStyles(({ spacing, typography, palette, breakpoints }) => ({
  root: {
    width: '100%',
    padding: ({ variant }) => variant === 'full' ? spacing(6, 12) : spacing(6, 0),
    backgroundColor: ({ variant }) => variant === 'full' ? palette.grey[50] : 'transparent',
    borderTop: ({ variant }) => variant === 'full' ? `1px solid ${palette.grey[300]}` : 'none',
    [breakpoints.down('md')]: {
      padding: ({ variant }) => variant === 'full' ? spacing(4, 3) : spacing(4, 0)
    }
  },
  container: {
    maxWidth: ({ variant }) => variant === 'full' ? 900 : '100%',
    margin: '0 auto',
    textAlign: 'center',
    padding: ({ variant }) => variant === 'compact' ? spacing(6, 4) : 0,
    backgroundColor: ({ variant }) => variant === 'compact' ? palette.grey[50] : 'transparent',
    borderRadius: ({ variant }) => variant === 'compact' ? spacing(2) : 0,
    border: ({ variant }) => variant === 'compact' ? `1px solid ${palette.grey[200]}` : 'none'
  },
  badgeContainer: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: spacing(3)
  },
  badge: {
    backgroundColor: palette.text.primary,
    color: palette.white.main,
    fontWeight: typography.weight.bold,
    fontSize: '0.75rem',
    letterSpacing: 1,
    padding: spacing(1, 2),
    height: 'auto',
    '& .MuiChip-icon': {
      color: palette.white.main,
      fontSize: 16,
      marginLeft: spacing(1)
    }
  },
  title: {
    ...typography.heading.h2,
    fontWeight: typography.weight.bold,
    color: palette.text.primary,
    marginBottom: spacing(3)
  },
  description: {
    ...typography.body.m,
    color: palette.text.secondary,
    lineHeight: 1.6,
    maxWidth: 700,
    margin: '0 auto',
    marginBottom: spacing(4)
  },
  primaryActionsContainer: {
    display: 'flex',
    gap: spacing(2),
    marginTop: spacing(3),
    marginBottom: spacing(4),
    justifyContent: 'center',
    flexWrap: 'wrap',
    [breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'stretch',
      '& button': {
        width: '100%'
      }
    }
  },
  secondaryActionsContainer: {
    display: 'flex',
    gap: spacing(2),
    marginTop: spacing(4),
    justifyContent: 'center',
    flexWrap: 'wrap',
    [breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'stretch',
      '& button': {
        width: '100%'
      }
    }
  },
  benefitsCard: {
    marginBottom: spacing(6),
    padding: spacing(4),
    backgroundColor: 'transparent',
    boxShadow: 'none'
  },
  benefitContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: spacing(2)
  },
  benefitIconContainer: {
    width: 56,
    height: 56,
    borderRadius: spacing(2),
    backgroundColor: palette.white.main,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  benefitIcon: {
    fontSize: 28,
    color: palette.text.primary
  },
  benefitTitle: {
    fontWeight: typography.weight.bold,
    marginBottom: 0
  },
  benefitDescription: {
    marginTop: 0
  },
  timelineContainer: {
    marginTop: spacing(8),
    paddingTop: spacing(6),
    borderTop: `1px solid ${palette.grey[300]}`,
    position: 'relative'
  },
  timelineBadge: {
    position: 'absolute',
    top: -16,
    left: '50%',
    transform: 'translateX(-50%)',
    backgroundColor: palette.grey[200],
    color: palette.text.primary,
    paddingLeft: spacing(2),
    paddingRight: spacing(2),
    paddingTop: spacing(1),
    paddingBottom: spacing(1),
    borderRadius: spacing(1),
    display: 'flex',
    alignItems: 'center',
    gap: spacing(0.5),
    boxShadow: 1,
    border: `1px solid ${palette.grey[300]}`
  },
  timelineBadgeIcon: {
    fontSize: 14
  },
  timelineBadgeText: {
    fontWeight: typography.weight.bold,
    fontSize: '0.65rem',
    letterSpacing: 1
  },
  timelineCard: {
    padding: spacing(4),
    boxShadow: 'none'
  },
  stepContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: spacing(1)
  },
  stepCircle: {
    width: 32,
    height: 32,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: spacing(1)
  },
  stepCircleComplete: {
    backgroundColor: palette.text.primary
  },
  stepCircleCurrent: {
    backgroundColor: palette.text.primary
  },
  stepCircleNext: {
    backgroundColor: palette.grey[300]
  },
  stepIcon: {
    fontSize: 18,
    color: palette.white.main
  },
  stepNumber: {
    color: palette.white.main,
    fontWeight: typography.weight.bold
  },
  stepNumberCurrent: {
    color: palette.white.main,
    fontWeight: typography.weight.bold
  },
  stepNumberNext: {
    color: palette.text.secondary,
    fontWeight: typography.weight.bold
  },
  stepStatusComplete: {
    fontWeight: typography.weight.bold,
    color: palette.text.primary
  },
  stepStatusCurrent: {
    fontWeight: typography.weight.bold,
    color: palette.primary.main
  },
  stepStatusNext: {
    fontWeight: typography.weight.bold,
    color: palette.text.secondary
  },
  stepLabel: {
    textAlign: 'center'
  },
  connectorLine: {
    height: 2,
    backgroundColor: palette.text.primary,
    display: { xs: 'none', sm: 'block' }
  },
  connectorLineInactive: {
    height: 2,
    backgroundColor: palette.grey[300],
    display: { xs: 'none', sm: 'block' }
  }
}))
